<section class="operations-overview">
  <div class="overview-heading">
    <div>
      <p class="eyebrow">{{ content.eyebrow }}</p>
      <h2>{{ content.title }}</h2>
    </div>
    <a [routerLink]="content.actionRoute" class="map-action">
      <i class="material-icons">map</i>
      <span>{{ content.actionLabel }}</span>
    </a>
  </div>

  <div class="operations-grid">
    <a *ngFor="let card of content.cards" [routerLink]="card.route" class="operations-card">
      <div class="card-icon">
        <i class="material-icons">{{ card.icon }}</i>
      </div>
      <div class="card-copy">
        <div class="card-kicker">{{ card.metric }}</div>
        <h3>{{ card.label }}</h3>
        <p>{{ card.description }}</p>
      </div>
      <i class="material-icons card-arrow">chevron_right</i>
    </a>
  </div>

  <div class="priority-panel">
    <div>
      <p class="eyebrow">{{ content.priorityEyebrow }}</p>
      <h3>{{ content.priorityTitle }}</h3>
    </div>
    <div class="priority-list">
      <span *ngFor="let priority of content.priorities">
        <i class="material-icons">check_circle</i>
        {{ priority }}
      </span>
    </div>
  </div>

  <div class="workflow-panel">
    <div class="workflow-heading">
      <p class="eyebrow">Operational workflow</p>
      <h3>From setup to live service</h3>
    </div>
    <div class="workflow-steps">
      <div class="workflow-step" *ngFor="let step of content.workflow">
        <i class="material-icons">{{ step.icon }}</i>
        <span>
          <strong>{{ step.label }}</strong>
          <small>{{ step.status }}</small>
        </span>
      </div>
    </div>
  </div>
</section>
